/**
 * Ein Apartmentwechsel verwirft Eingaben im Editor nie stillschweigend: solange der Editor
 * ungesicherte Werte hält, wartet ein Wechsel auf die Rückfrage.
 */
import { useState } from 'react';

export function useEditorGuard(selectedPropertyId: string | null) {
  const [dirty, setDirty] = useState(false);
  const [pending, setPending] = useState<(() => void) | null>(null);

  /** `afterConfirm` läuft statt `action`, wenn erst die Rückfrage kam (etwa: Ziehen ist vorbei). */
  const guard = (propertyId: string | null, action: () => void, afterConfirm = action) => {
    if (dirty && propertyId !== selectedPropertyId) setPending(() => afterConfirm);
    else action();
  };

  return {
    setDirty,
    guard,
    dialog: {
      open: pending !== null,
      onKeep: () => setPending(null),
      onDiscard: () => {
        setDirty(false);
        pending?.();
        setPending(null);
      },
    },
  };
}
